<template>
  <b-modal v-model="modalShow" centered scrollable>
    <template v-slot:modal-header>
      <div class="content-subject">{{ $t('common.howToUse') }}</div>
    </template>
    <div class="modal-container">
      <swiper ref="swiper" :options="swiperOption" class="tutorial-contents">
        <swiper-slide>
          <div class="tutorial-content">
            <div class="tutorial-inner">
              <div class="tutorial-image">
                <b-img :src="images[0]" alt="tutorial image" />
              </div>
              <div class="text-main">{{ $t('howToUse.canOrderWithSmartPhone') }}</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide v-if="!isUs">
          <div class="tutorial-content">
            <div class="tutorial-inner">
              <div class="tutorial-image">
                <b-img :src="images[1]" alt="tutorial image" />
              </div>
              <div class="text-main">{{ $t('howToUse.sideMenuAlsoCanMakeBikkuraPon') }}</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide v-if="isApp">
          <div class="tutorial-content">
            <div class="tutorial-inner">
              <div class="tutorial-image">
                <b-img :src="images[2]" alt="tutorial image" />
              </div>
              <div class="text-main">{{ $t('howToUse.canCompleteOrderBeforeMeal') }}</div>
              <div class="text-sub">{{ $t('howToUse.preOrderAfterReserved') }}</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="tutorial-content">
            <div class="tutorial-inner">
              <div class="tutorial-image">
                <b-img :src="images[3]" alt="tutorial image" />
              </div>
              <div class="text-main">{{ $t('howToUse.noLimitForOrder') }}</div>
              <div class="text-sub">{{ $t('howToUse.scanQrAndStart') }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <template v-slot:modal-footer>
      <div class="text-align-center">
        <so-close-button @click="handleClose">{{ $t('common.close') }}</so-close-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import config from '@/config/config'

import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  components: {
    SoCloseButton,
  },
  data() {
    return {
      images: [
        `${config.domain}/assets/image/tutorial/tutorial01.png`,
        `${config.domain}/assets/image/tutorial/tutorial02.png`,
        `${config.domain}/assets/image/tutorial/tutorial03.png`,
        `${config.domain}/assets/image/tutorial/tutorial04.png`,
      ],
      swiperOption: {
        loop: true,
        threshold: 10,
        observer: true,
        observeParents: true,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.isShowingTutorialModal
      },
      set(value) {
        this.showModal(value)
      },
    },
    ...mapGetters({
      isShowingTutorialModal: 'modal/isShowingTutorialModal',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modal/setShowingTutorialModal',
    }),
    handleClose() {
      this.showModal(false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-dialog {
    @media (max-width: 575px) {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
    &::before,
    &::after {
      content: '';
      display: block;
      flex-grow: 1;
    }
  }
  .modal-body {
    width: 100%;
    padding: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow: visible;
    overflow-y: visible !important;
  }
  .modal-header {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-bottom: none;
    font-weight: bold;
  }
  .modal-content {
    flex: 5;
    min-height: 260px;
    overflow: visible !important;
  }
  .modal-footer {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-top: none;
  }
  .swiper-wrapper {
    align-items: center;
  }
}
.swiper-button-prev {
  height: 60px;
  width: 60px;
  left: -30px;
  margin-top: -30px;
  background: url('../../assets/images/icn_arrow_red_prev.svg');
  &:focus {
    outline: none;
  }
}
.swiper-button-next {
  height: 60px;
  width: 60px;
  right: -30px;
  margin-top: -30px;
  background: url('../../assets/images/icn_arrow_red_next.svg');
  &:focus {
    outline: none;
  }
}
.modal-container {
  align-items: center;
  height: 100%;
}
.tutorial-contents {
  height: 100%;
  max-height: 100%;
}
.tutorial-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;

  .tutorial-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .tutorial-image {
    flex-grow: 1;
    flex-basis: 70%;
    position: relative;
    width: 100%;

    img {
      position: absolute;
      top: -50%;
      bottom: -50%;
      left: -50%;
      right: -50%;
      height: auto;
      max-height: 100%;
      width: auto;
      margin: auto;
    }
  }
  .text-main {
    flex-basis: 15%;
    padding: 0 8px 4px;
    line-height: 1.4;
    font-size: 16px;
    white-space: pre-wrap;

    @media (min-width: 500px) {
      white-space: normal;
    }
  }
  .text-sub {
    flex-basis: 15%;
    padding: 0 16px;
    line-height: 1.4;
    font-size: 12px;
    white-space: pre-wrap;
  }
}
</style>
